module.exports = __webpack_public_path__ + "img/Powered_by_StandApp_W.e21d04c6.svg";